import { createFileRoute } from '@tanstack/react-router';

import {
  AdminLimitsPage,
  limitsSearchSchema,
} from '@/features/organization-admin';

export const Route = createFileRoute('/admin/limits')({
  // The page's whole view lives in the address (spec 117 R3): the period the spend
  // figures cover, the search, filter and order, and the workspace whose sheet is open —
  // so the back button closes a sheet, and other pages can link straight to one.
  validateSearch: limitsSearchSchema,
  component: AdminLimitsRoute,
});

export function AdminLimitsRoute() {
  const { period, q, filter, sort, workspace } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AdminLimitsPage
      period={period}
      onPeriodChange={(next) => {
        void navigate({
          search: (prev) => ({ ...prev, period: next }),
          replace: true,
        });
      }}
      view={{ q, filter, sort, workspace }}
      onViewChange={(next) => {
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        });
      }}
    />
  );
}
